import React from 'react';
import DynamicFaIcon from '../../atoms/DynamicFaIcon';
import { useNavigate } from 'react-router-dom';

interface LayoutLearningProps {
    children?: React.ReactNode,
    btnBack: boolean
}

const LayoutLearning = (props: LayoutLearningProps) => {
    const { children, btnBack } = props;
    const navigate = useNavigate();
    return (
        <>
            <div className='container'>
                <nav className="fixed z-[999] p-4">
                    {
                        btnBack && (
                            <button className='p-2 cursor-pointer text-center rounded-lg bg-black/70 text-white' onClick={() => { navigate(-1) }}>
                                <DynamicFaIcon name={"FaArrowLeft"} />
                            </button>
                        )
                    }
                </nav>
                {children}
            </div>
        </>
    );
};

export default LayoutLearning;